import { render, staticRenderFns } from "./VesselContainerOverview.vue?vue&type=template&id=a818a3e6&scoped=true"
import script from "./VesselContainerOverview.vue?vue&type=script&lang=js"
export * from "./VesselContainerOverview.vue?vue&type=script&lang=js"
import style0 from "./VesselContainerOverview.vue?vue&type=style&index=0&id=a818a3e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a818a3e6",
  null
  
)

export default component.exports